module.exports = __webpack_public_path__ + "assets/images/text.9f64812.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/text.png
// module id = 651
// module chunks = 12